var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_182_73730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_182_73730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2999 20.4V18H2.3999V16.2H9.2999C9.78324 16.2 10.2041 16.3791 10.5624 16.7375C10.9207 17.0958 11.0999 17.5166 11.0999 18V20.4H9.2999ZM12.8999 20.4V18C12.8999 17.5166 13.0762 17.0958 13.4287 16.7375C13.7812 16.3791 14.2049 16.2 14.6999 16.2H21.5999V18H14.6999V20.4H12.8999ZM6.5999 15C5.7499 15 5.0374 14.7125 4.4624 14.1375C3.8874 13.5625 3.5999 12.85 3.5999 12V8.39998H20.3999V12C20.3999 12.85 20.1082 13.5625 19.5249 14.1375C18.9416 14.7125 18.2332 15 17.3999 15H6.5999ZM6.5999 13.2H17.3999C17.7399 13.2 18.0249 13.085 18.2549 12.855C18.4849 12.625 18.5999 12.34 18.5999 12V10.2H5.3999V12C5.3999 12.34 5.5149 12.625 5.7449 12.855C5.9749 13.085 6.2599 13.2 6.5999 13.2ZM3.5999 7.19998V5.39998H8.9999V4.49998C8.9999 4.26664 9.08375 4.05831 9.25145 3.87498C9.41917 3.69164 9.62699 3.59998 9.8749 3.59998H14.1249C14.3582 3.59998 14.5624 3.69164 14.7374 3.87498C14.9124 4.05831 14.9999 4.26664 14.9999 4.49998V5.39998H20.3999V7.19998H3.5999Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCooking);
export default __webpack_public_path__ + "static/media/cooking.2ccf72dc99d6c3bb783c4848f8723c9a.svg";
export { ForwardRef as ReactComponent };